import React from 'react';
import type ProjectSettingsServiceDeskItsmFeaturesType from '@atlassian/jira-spa-apps-project-settings-service-desk-itsm-features/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskItsmFeatures = lazyForPaint<
	typeof ProjectSettingsServiceDeskItsmFeaturesType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-itsm-features", jiraSpaEntry: "async-project-settings-service-desk-itsm-features" */ '@atlassian/jira-spa-apps-project-settings-service-desk-itsm-features'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskItsmFeatures}
		pageId="project-settings-itsm-features"
		shouldShowSpinner
	/>
);
